<template>
  <div class="video_button">
    <primary-button
      @click.native="modalOpen"
      :link="false"
      :label="label"
			:type="'video'"
    ></primary-button>

    <div
      class="modal"
      :class="{ open: isModalOpen == true }"
      @click="modalClose"
    >
      <div class="iframe__container" v-if="isModalOpen === true">
        <close-button  class="close_image" type='grey' @click.native="modalClose"></close-button>

        <iframe
          class="responsive__iframe"
          :src="video_source + setAutoplay"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import CloseButton from './CloseButton.vue';
import PrimaryButton from './PrimaryButton.vue';
export default {
  data() {
    return {
      isModalOpen: false,
      aosStatus: null,
      isAnimatedIn: false,
      window: {
        width: 0,
        height: 0,
      },
    };
  },

  props: {
    video_source: {
      type: String,
      default: '',
    },
    link: {},
    label: {},
  },

  computed: {
    setAutoplay() {
      if (this.isModalOpen === false) {
        return '?autoplay=0';
      } else {
        return '?autoplay=1';
      }
    },
  },

  watch: {},

  methods: {
    modalOpen() {
      this.sourceVideo = this.video_source;
      this.isModalOpen = true;
      this.$emit('isModalOpen', true);
      document.body.classList.add('modal-open');
    },

    modalClose() {
      this.sourceVideo = '';
      this.isModalOpen = false;
      this.$emit('isModalOpen', false);
      document.body.classList.remove('modal-open');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      document.body.classList.remove('modal-open');
      this.modalClose();
    },
  },

  components: { PrimaryButton, CloseButton },

  created() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('load', this.handleResize);
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    this.handleResize();
  },

  mounted() {
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },

  change() {
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.video_button {
  .modal {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.9);
    opacity: 0;
    pointer-events: none;
    transition: 0.2s ease all;
    z-index: 999;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: 1fr auto 1fr;
    justify-content: center;
    align-items: center;

    @media (max-width: $mobile) {
      grid-template-columns: 16px 1fr 16px;
    }

    @media (max-width: $mobile) and (orientation: landscape) {
      grid-template-columns: repeat(12, 1fr);
    }

    &.open {
      opacity: 1;
      pointer-events: all;
    }

    // iframe {
    //   grid-column: 3 / span 8;
    //   grid-row: 2 / span 1;
    // }

    .iframe__container {
      position: relative;
      // overflow: hidden;
      width: 100%;
      aspect-ratio: 16 / 9;
      grid-column: 3 / span 8;
      grid-row: 2 / span 1;
      min-width: 800px;
      min-height: 400px;

      @media (max-width: $tablet) {
        grid-column: 2 / span 1;
        align-items: center;
        min-width: 300px;
      }

      @media (max-width: $mobile) and (orientation: portrait) {
        min-width: 100%;
        min-height: 20vh;
        min-width: 300px;
      }

      @media (max-width: $mobile) and (orientation: landscape) {
        grid-column: 4 / span 6;
        min-width: 300px;
      }

      .close_image {
        display: flex;
        position: absolute;
        grid-column: 11 / span 1;
        z-index: 10;
        top: -50px;
        right: -50px;

        @media (min-width: 0px) {
          right: 0px;
          width: 24px;
          height: 24px;
        }
      }
    }

    /* Then style the iframe to fit in the container div with full height and width */
    .responsive__iframe {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      max-height: 100%;
      min-width: 100%;
      min-height: 400px;
      aspect-ratio: 16 / 9;

      @media (max-width: $mobile) {
        min-height: auto;
      }
    }
  }
}
</style>
